/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeBillingPortal
 */
export interface StripeBillingPortal {
    /**
     * 
     * @type {string}
     * @memberof StripeBillingPortal
     */
    url: string;
}

/**
 * Check if a given object implements the StripeBillingPortal interface.
 */
export function instanceOfStripeBillingPortal(value: object): value is StripeBillingPortal {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function StripeBillingPortalFromJSON(json: any): StripeBillingPortal {
    return StripeBillingPortalFromJSONTyped(json, false);
}

export function StripeBillingPortalFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeBillingPortal {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function StripeBillingPortalToJSON(json: any): StripeBillingPortal {
    return StripeBillingPortalToJSONTyped(json, false);
}

export function StripeBillingPortalToJSONTyped(value?: StripeBillingPortal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

